import Locations from "../sections/Locations";
import FAQSection from "../sections/FAQSection";
import { Phone, MessageCircle, Mail } from "lucide-react";
import { PHONE_DISPLAY, PHONE_TEL, WHATSAPP_URL, FAQS } from "../data/site";
import SEO from "../seo/SEO";
import {
  physicianSchema,
  medicalClinicSchemas,
  faqPageSchema,
  breadcrumbSchema,
  webPageSchema,
} from "../seo/schemas";

export default function Contact() {
  return (
    <main data-testid="contact-page">
      <SEO
        title="Contact Dr. Indresh Dixit — Gastro Clinics in Lanka & Chetganj, Varanasi"
        description="Book an appointment with Dr. Indresh Dixit on WhatsApp at +91 93696 98080. Two gastroenterology clinics in Varanasi — Lanka (morning) and Chetganj (evening)."
        canonical="/contact"
        schemas={[
          physicianSchema(),
          ...medicalClinicSchemas(),
          webPageSchema({
            name: "Contact Dr. Indresh Dixit — Varanasi",
            description:
              "Phone, WhatsApp and locations for Dr. Indresh Dixit's gastro clinics in Varanasi.",
            url: "/contact",
          }),
          faqPageSchema(FAQS),
          breadcrumbSchema([
            { label: "Home", url: "/" },
            { label: "Contact" },
          ]),
        ]}
      />

      <section className="section-pad border-b border-black/10">
        <div className="container-x">
          <div className="overline">Contact</div>
          <h1 className="font-serif-display mt-5 text-5xl sm:text-6xl lg:text-[72px] leading-[1.02] tracking-tight max-w-4xl">
            Book a Gastroenterologist in{" "}
            <span className="text-[#0370AD]">Varanasi.</span>
          </h1>
          <p className="mt-8 text-black/70 max-w-2xl text-[17px] leading-relaxed">
            For appointments, message us on WhatsApp — confirmation is usually
            within minutes during clinic hours. For urgent queries, call the
            clinic line directly.
          </p>

          <h2 className="sr-only">Ways to reach Dr. Indresh Dixit&apos;s clinic</h2>
          <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-px bg-black/10 border border-black/10 rounded-[6px] overflow-hidden">
            <a
              href={WHATSAPP_URL}
              target="_blank"
              rel="noreferrer"
              data-testid="contact-whatsapp"
              className="bg-white p-8 hover:bg-[#EAF6FD] transition-colors group"
            >
              <MessageCircle className="h-6 w-6 text-[#25D366]" />
              <div className="mt-5 overline">WhatsApp</div>
              <h3 className="mt-2 font-display-semibold text-2xl md:text-3xl">
                Book Appointment
              </h3>
              <div className="mt-3 text-[14px] text-black/65">
                Fastest reply · message-based booking
              </div>
            </a>
            <a
              href={PHONE_TEL}
              data-testid="contact-phone"
              className="bg-white p-8 hover:bg-[#EAF6FD] transition-colors"
            >
              <Phone className="h-6 w-6 text-[#0370AD]" />
              <div className="mt-5 overline">Phone</div>
              <h3 className="mt-2 font-display-semibold text-2xl md:text-3xl">
                {PHONE_DISPLAY}
              </h3>
              <div className="mt-3 text-[14px] text-black/65">
                Clinic reception · Mon–Sat
              </div>
            </a>
            <div data-testid="contact-email" className="bg-white p-8">
              <Mail className="h-6 w-6 text-black/65" />
              <div className="mt-5 overline">Walk-in</div>
              <h3 className="mt-2 font-display-semibold text-2xl md:text-3xl">
                Walk-ins welcome
              </h3>
              <div className="mt-3 text-[14px] text-black/65">
                Booked patients are seen first
              </div>
            </div>
          </div>
        </div>
      </section>

      <Locations headingTag="h2" />
      <FAQSection headingTag="h2" />
    </main>
  );
}
